const getNewTimeWithShift = (
    interval: number,
    currentTime: number,
    totalTime: number,
) => {
    const newTime = currentTime + interval;

    const isTooBig = newTime >= totalTime;
    const isTooSmall = newTime <= 0;

    return isTooBig || isTooSmall ? 0 : newTime;
};

export default getNewTimeWithShift;
